import Login from '@auth/pages/Login';
import Signup from '@auth/pages/Signup';
import NotFound from './pages/NotFound';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import AuthLayout from './features/auth/components/auth.layout';
import CreateProfile from './pages/CreateProfile';
import Dashboard from './features/dashboard/pages/Dashboard';
import { diagramLoader } from './features/diagram/ui/diagram.loader';
import Diagram from './features/diagram/ui/diagram.page';
import NotAuthorized from './features/auth/pages/NotAuthorized';
import LimitExceeded from './features/billing/pages/LimitExceeded';
import { ReactFlowProvider } from '@xyflow/react';
import ProtectedLoader from './router/loaders/protected.loader';
import App from './App';
import { loginLoader } from './router/loaders/login.loader';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Navigate to="/auth/login" /> },
      {
        path: '/auth',
        element: <AuthLayout />,
        children: [
          {
            path: 'login',
            index: true,
            loader: loginLoader,
            element: <Login />,
            handle: { title: 'Login to your account' },
          },
          {
            path: 'signup',
            element: <Signup />,
            handle: { title: 'Create a new account' },
          },
        ],
      },
      {
        path: '/v1',
        loader: ProtectedLoader,
        handle: { requiredRole: null },
        children: [
          {
            path: 'create-profile',
            element: <CreateProfile />,
          },
          {
            path: 'dashboard',
            element: <Dashboard />,
          },
          {
            path: 'diagram/:id',
            loader: diagramLoader,
            element: (
              <ReactFlowProvider>
                <Diagram />
              </ReactFlowProvider>
            ),
          },
        ],
      },
      {
        path: '/billing/limit-exceeded',
        element: <LimitExceeded />,
      },
      {
        path: '/not-authorized',
        element: <NotAuthorized />,
      },

      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);
